import { GuardedDeletionService, GeneticMaterialTypeService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  GeneticMaterialTypeCreateDto,
  GeneticMaterialTypeDto,
  GeneticMaterialTypeExcelDownloadDto,
  GeneticMaterialTypeUpdateDto,
} from '../proxy/general/dtos/genetic-material-type';
import { GENETICMATERIALTYPE_CONFIG, GENETICMATERIALTYPE_FIELDS } from './genetic-material-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-genetic-material-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, GeneticMaterialTypeService, ConfirmationService],
  templateUrl: './genetic-material-type.html',
  styleUrl: './genetic-material-type.scss',
})
export class GeneticMaterialType extends BaseCrudComponent<
  GeneticMaterialTypeDto,
  GeneticMaterialTypeCreateDto,
  GeneticMaterialTypeUpdateDto,
  GeneticMaterialTypeExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(GeneticMaterialTypeService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('GeneticMaterialType', ids),
  };
  config = GENETICMATERIALTYPE_CONFIG;
  fields = GENETICMATERIALTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: GeneticMaterialTypeDto): GeneticMaterialTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'GeneticMaterialType';
  }
}
